import { z } from 'zod'

import { dbEntitySchema } from './system'
import { NotificationSettingType } from '../constants/notificationSetting'

const notificationChannelsSchema = z.object({
  email: z.boolean(),
  sms: z.boolean(),
  push: z.boolean(),
})

const notificationChannelsArgsSchema = z.object({
  email: z.boolean().optional(),
  sms: z.boolean().optional(),
  push: z.boolean().optional(),
})

export const notificationSettingSchema = dbEntitySchema.extend({
  organizationMember: z.string().optional().nullable(),
  organization: z.string().optional().nullable(),
  managementUser: z.string(),
  venue: z.string().optional().nullable(),
  type: z.nativeEnum(NotificationSettingType),
  notifications: notificationChannelsSchema,
})

/**
 * `managementUserId` is optional at the API surface because legacy callers
 * pass only `organizationMemberId` and the service resolves the management
 * user from it. Service-level validation enforces presence for ADMIN-only
 * types where there is no orgMember to resolve from.
 */
export const notificationSettingCreateArgsSchema = z.object({
  managementUserId: z.string().optional().nullable(),
  organizationMemberId: z.string().optional().nullable(),
  organizationId: z.string().optional().nullable(),
  venueId: z.string().optional().nullable(),
  type: z.nativeEnum(NotificationSettingType),
  notifications: notificationChannelsArgsSchema,
})

export const notificationSettingUpdateByIdArgsSchema = z.object({
  notifications: notificationChannelsArgsSchema,
})

export const notificationSettingUpsertArgsSchema = z.object({
  managementUserId: z.string(),
  venueId: z.string().optional().nullable(),
  type: z.nativeEnum(NotificationSettingType),
  notifications: notificationChannelsArgsSchema,
})

export type NotificationSettingCreateArgs = z.infer<
  typeof notificationSettingCreateArgsSchema
>
export type NotificationSettingUpdateByIdArgs = z.infer<
  typeof notificationSettingUpdateByIdArgsSchema
>
export type NotificationSettingUpsertArgs = z.infer<
  typeof notificationSettingUpsertArgsSchema
>
